import { Col, Form, Row } from 'react-bootstrap';

const ManutencaoEquipamentos = props => {
  return (
    <>
      <Row>
        <Col sm={12}>
          <Form.Group controlId="equipamentoEngenhariaClinica" className="mt-4">
            <Form.Label>*Equipamento:</Form.Label>
            <Form.Select
              className="border border-secondary"
              required
              name="equipamentoEngenhariaClinica"
              onChange={e => props.handleEquipamentoEngenhariaClinica(e)}
              value={props.equipamentoEngenhariaClinica}
            >
              <option value="">Selecione o equipamento:</option>
              {props.equipamentosEngenhariaClinica.map(equipamento => (
                <option key={equipamento} value={equipamento}>{equipamento}</option>
              ))}
            </Form.Select>
          </Form.Group>
        </Col>
      </Row>
    </>
  );
};

export default ManutencaoEquipamentos;
